import styled from 'styled-components';

export default styled.div`
  grid-area: user;
  font-size: 0.9rem;
  align-self: start;
`;
